export default "__VITE_ASSET__D3f77$Cl__"